import React, { Component } from "react";
import { connect } from "react-redux";
import { dashboardActions } from "../../../_actions";
import LayoutWrap from "../Component/LayoutWrap";
import { LuArrowLeft } from 'react-icons/lu';

const isMobile = window.innerWidth <= 700;

class ReadingCaseStudy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeChapter: 0,
      activeId: 2,
      activeDetail: false
    };
  }

  componentDidMount() {
    this.props.dispatch(dashboardActions.getConnectDetails({}));
    this.props.dispatch(dashboardActions.saveInsightActivityTracking({
      activity: "Viewing Case Study!"
    }));
    let data = {};
    this.props.dispatch(dashboardActions.getCaseStudyDetails(data));
  }

  setChapter = (index) => {
    if (isMobile) {
      this.setState({ activeDetail: true });
    }
    this.setState({ activeChapter: index });
  };

  nextChapter = () => {
    let { dashboard } = this.props;
    let { getCaseStudyDetailsData = [] } = dashboard;

    if (this.state.activeChapter < getCaseStudyDetailsData.length - 1) {
      this.setState({ activeChapter: this.state.activeChapter + 1 });
    }
  };

  prevChapter = () => {
    if (this.state.activeChapter > 0) {
      this.setState({ activeChapter: this.state.activeChapter - 1 });
    }
  };

  handleChapterClick = (id) => {
    this.setState({ activeId: id });
  };

  goToBack = () => {
    let { activeDetail } = this.state;
    if (isMobile) {
      if (activeDetail) {
        this.setState({ activeDetail: false });
      } else {
        window.history.back();
      }
    } else {
      window.history.back();
    }

  };


  render() {
    let { activeChapter, activeDetail } = this.state;
    let { dashboard } = this.props;
    let { getCaseStudyDetailsData = [] } = dashboard;

    let currentChapter = {};
    if (getCaseStudyDetailsData && getCaseStudyDetailsData.length > 0) {
      currentChapter = getCaseStudyDetailsData[activeChapter];
    }
    const { activeId } = this.state;

    const caseStudyData = {
      title: "Case Study Reading & Preparation",

      chapters: Array.isArray(getCaseStudyDetailsData)
        ? getCaseStudyDetailsData.map((chapter, index) => ({
          id: chapter?.id ?? "",
          index: index,
          title: chapter?.chapterName ?? "",
          chapter: "Chapter " + (index + 1)
        }))
        : [],

      content: {
        heading: currentChapter?.chapterName ?? "",
        subChapter: "Chapter " + (activeChapter + 1),
        sections: Array.isArray(currentChapter?.paragraphs)
          ? currentChapter.paragraphs.map((para, i) => ({
            title: para?.paraTitle ?? "",
            subject: para?.paraSubtitle ?? "",
            text: para?.paraDesc ?? "",
          }))
          : [],
      },
    };


    let { getConnectDetailsData: x } = dashboard;
    let logo = x?.logo || "";

    return (
      <LayoutWrap logo={logo}>
        <div className="w-full mx-auto p-4 md:p-6 font-sans text-[#212121]">
          {/* Header */}
          <div className="sticky top-0 flex items-center gap-4 mb-8 pt-2 pb-4 border-b border-gray-300 bg-white z-10">
            <button onClick={() => this.goToBack()} className="p-2 rounded-full bg-indigo-100 text-indigo-600">
              <LuArrowLeft size={24} />
            </button>
            <h1 className="md:text-2xl text-xl font-medium textblack">{caseStudyData.title}</h1>
          </div>

          {/* Hero Image */}
          {(isMobile === true ? (!activeDetail) : true) &&
            <div className="w-full h-64 rounded-lg overflow-hidden mb-10 hidden lg:block">
              <img src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=1200&q=80" alt="Team collaboration" className="w-full h-full object-cover" />
            </div>
          }


          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
            {/* Sidebar Navigation */}

            {(isMobile === true ? (!activeDetail) : true) &&
              <div className="lg:col-span-4">
                <div className="sticky top-[4.6rem] space-y-0 border border-gray-300 rounded-xl overflow-hidden h-fit">
                  {caseStudyData.chapters.map((item, index) => (
                    <button
                      key={item.id}
                      onClick={() => this.setChapter(index)}
                      className={`w-full text-left px-6 py-3 transition-all border-b border-gray-300 last:border-b-0 flex flex-col ${isMobile ? false : (activeChapter === index)
                        ? 'bg-indigo-100 border-r-4 border-r-indigo-600'
                        : 'hover:bg-gray-50'
                        }`}
                    >
                      <span className={`font-medium text-lg ${isMobile ? false : (activeChapter === index) ? 'text-[#212121]' : 'textblack'}`}>{item.title}</span>
                      <span className="text-indigo-600 text-sm font-medium capitalize mt-1">{item.chapter}</span>
                    </button>
                  ))}
                </div>
              </div>
            }


            {/* Content Area */}
            {(isMobile === true ? (activeDetail) : true) &&
              <div className="lg:col-span-8">
                <header className="mb-8">
                  <h2 className="text-3xl font-semibold mb-2">{caseStudyData.content.heading}</h2>
                  <span className="text-gray-600 font-medium capitalize cursor-text">{caseStudyData.content.subChapter}</span>
                </header>

                <div className="space-y-8">
                  {caseStudyData.content.sections.map((section, index) => (
                    <section key={index} className="space-y-4">
                      <h3 className="text-xl font-semibold text-[#1a1a1a]">{section.title}</h3>
                      <div
                        className="text-gray-600 leading-relaxed text-base"
                        dangerouslySetInnerHTML={{ __html: section.text }}
                      />
                    </section>
                  ))}
                </div>
              </div>
            }

          </div>
        </div>
      </LayoutWrap>
    );
  }
}

const mapStateToProps = (state) => ({
  loggingIn: state.authentication?.loggingIn,
  dashboard: state.dashboard,
});

export default connect(mapStateToProps)(ReadingCaseStudy);